import '../assets/css/footer.css';
import cgLogo from '../assets/images/Capgemini_Logo_Color_RGB.svg';


const Footer = () => {
    
    return (
        <>
            <div className="footer">
                
            <ul className="no-box">
                        
                        <li><a href="https://www.capgemini.com/terms-of-use/" >Terms of Use</a></li>
                        <li><a href="https://www.capgemini.com/privacy-policy/" >Privacy Policy</a></li>
                        <li><a href="https://www.capgemini.com/legal-information-mentions-legales/" >Legal Information</a></li>
                        
                       
                    </ul>

                    <div className="cg-copyright">All rights reserved by Capgemini. Copyright © 2021</div>
                    <div className="footer-logo d-flex">
                            <img src={cgLogo} alt="Capgemini Logo" width="150" />
                        </div>
            </div>
        </>
    );
}

export default Footer;